import { isNullOrEmpty, isWebMobile, showMessageToastCustom, translate } from './util';

function set(obj, path, value, rowIndex) {
    for (let i = 0; i < path.length; i += 1) {
        if (i === path.length - 1) {
            if (rowIndex >= 0 && path[0].indexOf('[]') >= 1 && path[0].replace('[]', '') in obj) {
                obj[path[0].replace('[]', '')][rowIndex][path[i]] = value;
            } else if (rowIndex >= 0 && path[i].indexOf('[]') >= 1 && path[i].replace('[]', '') in obj) {
                obj[path[i].replace('[]', '')][rowIndex] = value;
            } else {
                obj[path[i]] = value;
            }
        } else if (rowIndex >= 0 && path[i].indexOf('[]') >= 1 && path[i].replace('[]', '') in obj) {
            obj = obj[path[i].replace('[]', '')][rowIndex];
        } else {
            obj = obj[path[i]];
        }
    }
}

export const onValueChangeByValue = (event, value, context, setContext) => {
    let index = 0;
    let field = event.target.name;

    set(context, field.split('.'), value, index);
    setContext((prevState) => { return { ...prevState, ...context }; });
};

export const onValueChange = (event, context, setContext) => {
    let index = 0;
    let field = event.target.name;
    let value;

    if (event.target.name.includes('[')) {
        const indiceAbre = event.target.name.indexOf('[');
        const indiceFecha = event.target.name.lastIndexOf(']');
        index = parseInt(event.target.name.substring(indiceAbre + 1, indiceFecha), 10);
        field = event.target.name.replace(`[${index}]`, '[]');
    }

    if (event.target.type === 'number' && event.target.value) {
        value = parseFloat(event.target.value);
    } else {
        value = event.target.value;
    }

    if (event.target.type === 'checkbox') {
        value = event.target.checked;
    }

    set(context, field.split('.'), value, index);
    setContext((prevState) => { return { ...prevState, ...context }; });
};

function setRow(event, obj) {
    const vetor = event.target.name.split('.');
    for (let i = 0; i < vetor.length; i += 1) {
        if (vetor[i].includes('[')) {
            const indiceAbre = vetor[i].indexOf('[');
            const indiceFecha = vetor[i].lastIndexOf(']');
            const index = parseInt(vetor[i].substring(indiceAbre + 1, indiceFecha), 10);
            const field = vetor[i].replace(`[${index}]`, '');
            obj = obj[field][index];
        } else if (vetor.length - 1 === i) {
            obj[vetor[i]] = event.target.value;
        } else {
            obj = obj[vetor[i]];
        }
    }
}

export const onRowChange = (event, context, setContext) => {
    setRow(event, context);
    setContext([...context]);
};

export const validation = (inputRef) => {
    let dataError = false;
    let message = "";
    if (inputRef) {
        const maxLength = inputRef.maxLength === -1 ? undefined : inputRef.maxLength;
        const minLength = inputRef.minLength === -1 ? undefined : inputRef.minLength;
        const length = !isNullOrEmpty(inputRef.value) ? inputRef.value.length : 0;

        if (inputRef.required && isNullOrEmpty(inputRef.value)) {
            validate = false;
            dataError = true;
            message = translate('required', 'validations');
        }

        if (maxLength && length > maxLength) {
            validate = false;
            dataError = true;
            message = translate('max-length-field', 'validations', { length: maxLength });
        }

        if (minLength && length < minLength) {
            validate = false;
            dataError = true;
            message = translate('min-length-field', 'validations', { length: minLength });
        }

        if (!isNullOrEmpty(inputRef.value) && inputRef.step === "1" && (inputRef.value.includes(".") || inputRef.value.includes(","))) {
            validate = false;
            dataError = true;
            message = translate('step-number', 'validations');
        }

        if (dataError) {
            inputRef.classList.add('invalid');
            let element = inputRef.parentElement.getElementsByClassName('helper-text')[0];
            if (element !== null && element !== undefined) {
                element.setAttribute('data-error', message);
            } else {
                element = document.createElement('span');
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', message);
                inputRef.parentElement.appendChild(element);
            }
        }
    }

    if (!dataError) {
        inputRef.classList.remove('invalid');
        const elRemove = inputRef.parentElement.getElementsByClassName('helper-text')[0];
        if (elRemove !== null && elRemove !== undefined) {
            inputRef.parentElement.removeChild(elRemove);
        }
    }
};

const validationSelect = (select) => {
    if (select) {
        if (select.required && isNullOrEmpty(select.value)) {
            select.parentNode.classList.add('invalid');
            let element = select.parentNode.parentElement.getElementsByClassName('helper-text')[0];
            const message = translate('required', 'validations');
            if (element !== null && element !== undefined) {
                element.setAttribute('data-error', message);

                if (isWebMobile()) {
                    element.innerHTML = message;
                    element.setAttribute('style', 'color:#ff0000 !important;');
                }
            } else {
                element = document.createElement('span');
                element.setAttribute('class', 'helper-text');
                element.setAttribute('data-error', message);

                if (isWebMobile()) {
                    element.innerHTML = message;
                    element.setAttribute('style', 'color:#ff0000 !important;');
                }
                select.parentNode.parentElement.appendChild(element);
            }
            validate = false;
        } else {
            select.classList.remove('invalid');
            const elRemove = select.parentNode.parentElement.getElementsByClassName('helper-text')[0];
            if (elRemove !== null && elRemove !== undefined) {
                select.parentNode.parentElement.removeChild(elRemove);
            }
        }
    }
}

let validate;
export function validateInputsRequired(form) {
    try {
        validate = true;
        let fields = undefined;
        let fieldsDrop = undefined;
        let forms = undefined;

        if (!isNullOrEmpty(form)) {
            forms = document.getElementById(form);
            if (forms) {
                fields = forms.querySelectorAll('Input');
                fieldsDrop = forms.querySelectorAll('Select');
            }
        }
        else {
            fields = document.querySelectorAll('Input');
            fieldsDrop = document.querySelectorAll('Select');
        }

        if (fields) {
            fields.forEach((f) => {
                validation(f);
            });
        }

        if (fieldsDrop) {
            fieldsDrop.forEach((f) => {
                if (f.id !== 'slUserVision') {
                    validationSelect(f);
                }
            });
        }

    } catch (error) {
        showMessageToastCustom(translate('warning', 'general'), `validateInputsRequired - ${error?.message}`, 8000, 'mdi mdi-alert-circle-outline red-text');
    }

    return validate;
}
